import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  Button,
  Chip,
} from "@mui/material";





const GenerateCodeTable = ({rows}) => {
    const statusColors = {
        Active: "success",
        Inactive: "error",
      };
      
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleGenerateCode = (id: number) => {
    alert(`Code generated for ID: ${id}`);
  };

  return (
    <Paper sx={{ width: "100%", overflow: "hidden", mt: 2, p: 2 }}>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell><strong>Name</strong></TableCell>
              <TableCell><strong>Email</strong></TableCell>
              <TableCell><strong>Phone</strong></TableCell>
              <TableCell><strong>Role</strong></TableCell>
              <TableCell><strong>Branch</strong></TableCell>
              <TableCell><strong>Generate Code</strong></TableCell>
              <TableCell><strong>Status</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>

    
            {rows?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row,i) => (
              <TableRow key={i}>
                <TableCell>{row.fullName}</TableCell>
                <TableCell>{row.email}</TableCell>
                <TableCell>{row.phone}</TableCell>
                <TableCell>{row?.roleName.toUpperCase()}</TableCell>
                <TableCell>{row?.branchName}</TableCell>
                <TableCell>
                {row?.activationCode?.toUpperCase()}
                </TableCell>
                <TableCell>
                  <Chip
                    label={row.status == 1 ? "Active" : "Inactive"}
                    color={statusColors[row.status == 1 ? "Active" : "Inactive" as keyof typeof statusColors]}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination */}
      <TablePagination
        component="div"
        count={rows ? rows.length : 1}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={handleChangePage}
        rowsPerPageOptions={[10, 25, 50]}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
};

export default GenerateCodeTable;
